var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background", on: { click: _vm.closeFilters } },
    [
      _c("smart-back-button", { attrs: { backToLabel: _vm.backToLbl } }),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "users-grid-wrapper px-5 py-5 br-10" },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "dropZone",
                                _vm.draggingFile ? "dropZone-over" : "",
                              ],
                              on: {
                                dragover: function ($event) {
                                  _vm.draggingFile = true
                                },
                                dragleave: function ($event) {
                                  _vm.draggingFile = false
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { on: { drag: _vm.onFileChanged } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.ic_file_upload_empty_state,
                                      },
                                    }),
                                  ]),
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "label",
                                      { staticClass: "select-file-lbl" },
                                      [
                                        _vm._v(
                                          " Select a file or drag and drop here "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "gray-text" },
                                        [
                                          _vm._v(
                                            " Max file size: 10MB. Max 1 file. "
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c(
                                        "label",
                                        { staticClass: "gray-text" },
                                        [
                                          _vm._v(
                                            " Allowed File Extensions: .xlsx "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("smart-btn", {
                                        attrs: {
                                          type: "primary",
                                          label: "Select File",
                                        },
                                        on: { click: _vm.handleFileImport },
                                      }),
                                      _c("input", {
                                        ref: "fileUploader",
                                        staticClass: "d-none",
                                        attrs: {
                                          type: "file",
                                          accept: ".xlsx",
                                        },
                                        on: { change: _vm.onFileChanged },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("input", {
                                attrs: { type: "file" },
                                on: { change: _vm.onFileChanged },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }